import React from "react";
import EmblaCarousel from "../careers/carousel/Carousel";

interface ITestimonial {
  id: number;
  name: string;
  description: string;
  position: string;
  image: string;
  linkedin: string;
}

interface TestimonialProps {
  title: string;
  smallDecription: string;
}

const CareerTestimonials: React.FC<TestimonialProps> = ({
  title,
  smallDecription,
}) => {
  const testimonials: ITestimonial[] = [
    {
      id: 1,
      name: "Anu",
      image: "/careers/testimonials/testimonial-1.png",
      description:
        "Being a part of Dream Weavers since 2018 has been an enriching experience filled with continuous learning and growth. As a Centre Coordinator, I have seen the company’s dedication to excellence and its unwavering support for both employees and clients. The dynamic and collaborative work environment has helped me develop both professionally and personally. I take immense pride in being part of an organization that truly values innovation, teamwork, and a shared vision for success.",
      position: "Centre Coordinator",
      linkedin: "linkedin.com/in/sarahchen",
    },
    {
      id: 2,
      name: "Nancy Sharma",
      image: "/careers/testimonials/testimonial-2.png",
      description:
        "Working at Dream Weavers has been an incredibly rewarding journey. Since joining in 2021, I have experienced an environment that encourages leadership, creativity, and professional development. As a Team Leader, I have had the opportunity to work with an amazing team that is dedicated to making a difference. The support and guidance provided by the management have been instrumental in shaping my career, and I feel truly valued and empowered in my role.",
      position: "Team Leader (CC)",
      linkedin: "linkedin.com/in/mrodriguez",
    },
    {
      id: 3,
      name: "Monna",
      image: "/careers/testimonials/testimonial-3.png",
      description:
        "My journey with Dream Weavers has been both inspiring and fulfilling. As an RTF Manager, I have had the privilege of working in an organization that genuinely cares about its employees and their growth. The company fosters a culture of innovation and teamwork, providing the perfect environment for skill development and career advancement. I am grateful for the trust and opportunities I have received here and look forward to contributing further to the company’s success.",
      position: "RTF Manager",
      linkedin: "linkedin.com/in/priyapatel",
    },
    {
      id: 4,
      name: "Kuldeep",
      image: "/careers/testimonials/testimonial-4.png",
      description:
        "Dream Weavers has provided me with an incredible platform to grow and excel in my career. Since joining in 2019 as a Placement Manager, I have had the opportunity to connect with talented individuals and help shape their futures. The company’s commitment to quality and employee development is truly commendable. Working in such a dynamic and supportive environment has been a rewarding experience, and I am proud to be part of this exceptional team.",
      position: "Placement Manager",
      linkedin: "linkedin.com/in/davidkim",
    },
    {
      id: 5,
      name: "Puneet Singh",
      image: "/careers/testimonials/testimonial-5.png",
      description:
        "Since joining Dream Weavers in 2019, I have experienced a workplace that truly values its employees and their contributions. The company provides a perfect balance of challenge and opportunity, helping me grow both professionally and personally. As a NOC Engineer, I have been encouraged to explore new technologies, refine my skills, and collaborate with a fantastic team. It’s an honour to be part of a company that continuously strives for excellence and innovation.",
      position: "NOC Engineer",
      linkedin: "linkedin.com/in/emmathompson",
    },
  ];
  return (
    <div>
      <div className="w-full flex justify-center items-center">
        <div className="text-center max-w-6xl xl:pt-5">
          <h3 className="text-xl text-center font-light xl:text-6xl sm:text-2xl md:text-3xl lg:text-4xl">
            {title}
          </h3>
          <p className="text-neutral-600 pt-2 xl:pt-4 xl:text-[1.6rem] font-light">
            {smallDecription}
          </p>
        </div>
      </div>
      <div className="py-5 p-2 sm:py-7 xl:px-20">
        <EmblaCarousel slides={testimonials} />
      </div>
    </div>
  );
};

export default CareerTestimonials;
